import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import LoadingScreen from "./loading/LoadingScreen";
import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import { useMediaQuery } from "react-responsive";
import HomeMobile from "./pages/HomeMobile";
import FooterMobile from "./components/Mobile/FooterMobile";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Error from "./pages/Error";


export default function App() {
  const [isLoading, setIsLoading] = useState(true);

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 680px)' });

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (    
    <>
    {isTabletOrMobile ? (
      <div className="bg-gray-400 rounded-lg bg-clip-padding backdrop-filter backdrop-blur-[1px] bg-opacity-10 border-[10px] border-gray-100 w-[90vw] h-[85vh] overflow-hidden relative -top-8">
        {isLoading ? (
        <LoadingScreen />
        ) : (
          <>
            <Navbar />
            <Router>
              <Routes>
                <Route path="/" element={<HomeMobile />} />
                <Route path="*" element={<Error />} />
              </Routes>
            </Router>
            <FooterMobile />
            <ToastContainer />
          </>
        )}
      </div>
    ) : (
      <div className="bg-gray-400 rounded-lg bg-clip-padding backdrop-filter backdrop-blur-[1px] bg-opacity-10 border-[10px] border-gray-100 w-[80vw] h-[80vh] overflow-hidden">
      {isLoading ? (
        <LoadingScreen />
      ) : (<>
            <Navbar />
            <Router>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="*" element={<Error />} />
              </Routes>
            </Router>
            <Footer />
            <ToastContainer />
          </>)}
      </div>
    )}
    
  </>
  );
}